import { render, staticRenderFns } from "./BpProfitLossBarChart.vue?vue&type=template&id=306434ed"
import script from "./BpProfitLossBarChart.vue?vue&type=script&lang=ts"
export * from "./BpProfitLossBarChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports